export default {
  hotkey: 'Shortcut description',
  delpoint: 'Delete the point',
  cancelpoint: 'Cancel the last point',
  finish: 'Done',
  submit: 'Submit',
  tool: 'tool',
  alt: 'Press and hold alt to enter the moving picture mode, release and switch to the original mode.',
  shift: 'Press and hold shift to enter the preview mode, release and switch to the original mode.',
  ctrl: 'In the rectangle mode, press and hold ctrl to enter the rectangle selection and movement mode, you can select and move the rectangle, release it and enter the drawing rectangle mode.',
  zoom: 'Sliding the mouse wheel will zoom in and out based on the cursor.',
  rightclick: 'Right Click and rotate the picture clockwise with the cursor as the center.',
  currtag: 'Current tag',
  do: 'Operation',
  task: 'Task',
  valid: `Don't forget checking the result before submit :)`,
  tagmax: 'Number of annotated items exceeds the amximum',
  tagmin: 'Number of annotated items is less than the minimum',
  validinfo1: 'annotation task (point drawing) is not completed',
  validinfo2: 'please finish the task',
  validinfo3: 'annotation task (polygon or polyline drawing) is not completed',
  validinfo4: 'annotation task (curve drawing) is not completed',
  validinfo5: 'not finish all task',
  validinfo6: 'No.',
  validinfo7: 'is not finished',
  validinfo8: 'Cannot be done in move mode, please switch to the corresponding mode',
  validinfo9: 'number of points is more than',
  validinfo10: 'number of points is less than',
  validinfo11: 'after deleting points, number of points is less than',
  validinfo12: 'page not transcribed',
  determine: 'determine',
  cancel: 'Cancel operation',
  error: 'Failure',
  pcd01: 'Auxiliary picture',
  pcd02: 'Reset position',
  pcd03: 'Take the previous frame',
  pcd04: 'Three View',
  pcd05: 'Zoom in',
  pcd06: 'Zoom out',
  pcd07: 'overlap',
  pcd08: 'isaddpt',
  pcd09: 'fixselect',
  dicom: 'Observed',
  normal01: 'Preset',
  group01: 'Picture labeling',
  group02: 'Subgraphs labeling',
  semantic01: 'Color mark',
  delete: 'successfully deleted',
  tips01: 'This action will delete all labeled items，whether to continue？',
  tips02: 'Delete operation，the label of this item in all frames will be deleted！！',
  tips03: 'Unmarked area exists:',
  tips04: 'warning: Label items different from the selected type, switch to new label item',
  tips05: 'warning: Curlist already exists,',
  tips06: 'annotated item, switch to new label item',
  head01: 'Fanhan Tool',
  head02: 'Press and drag the mouse to draw a rectangular area',
  head03: 'Click the mouse to make a point after all the points are made and click',
  head04: 'Click on the beginning and end of the line segment and then click',
  head05: 'Click the mouse to connect the points into a curve in the order of clicking',
  head06: 'Click the mouse for pointing',
  head07: 'Continuous dotting when used with polygons or dashes',
  head08: 'Complete a drawing',
  head09: 'Submit a task',
  head10: 'Exit',
  head11: 'Exit'
}



// WEBPACK FOOTER //
// ./src/lang/en/imgtemplate.js